try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
  require('slick-carousel');
  require('particles.js');
} catch (e) {}

bodyScrollLock = require('body-scroll-lock');

window.initMap = function initMap() {
  // Offices
  let swe = {
    info: '<div class="marker-info"><p>' +
        'Stureplan 2<br>' +
        '114 46 Stockholm<br>' +
        'Sweden</p></div>',
    lat: 59.335899,
    lng: 18.073090,
  };

  // TODO: Hidden til January by request of Nilsson
  // let uk = {
  //   info: '<div class="marker-info"><p>' +
  //       '1 Lindsey Street<br>' +
  //       'London, EC1A 9HP<br>' +
  //       'United Kingdom</p></div>',
  //   lat: 53.586240,
  //   lng: 0.641360,
  // };
  //
  // let us = {
  //   info: '<div class="marker-info"><p>' +
  //       '270 Lafayette Street<br>' +
  //       'Suite 1406<br>' +
  //       'NY 10012<br>' +
  //       'New York, United States</p></div>',
  //   lat: 40.723930,
  //   lng: -73.996510,
  // };
  //
  // let br = {
  //   info: '<div class="marker-info"><p>' +
  //       'Helbor Offices Vila Rica<br>' +
  //       'Avenida Conselheiro Nebias<br>' +
  //       '754, Sala 2411 Boqueirão<br>' +
  //       'Santos, Sao Paulo </p></div>',
  //   lat: -23.712100,
  //   lng: -46.502520,
  // };

  // Array with offices information
  let locations = [
    [swe.info, swe.lat, swe.lng],
    // [uk.info, uk.lat, uk.lng],
    // [us.info, us.lat, us.lng],
    // [br.info, br.lat, br.lng],
  ];

  // Map
  function getZoomSize() {
    if ($(window).width() <= 960) {
      return 3;
    } else {
      return 4;
    }
  }

  let map = new google.maps.Map($('#map')[0], {
    center: {lat: 59.335899, lng: 18.073090},
    zoom: getZoomSize(),
    disableDefaultUI: true,
    styles: [
      {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'visibility': 'off',
          },
        ],
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'visibility': 'off',
          },
        ],
      },
      {
        'featureType': 'all',
        'elementType': 'labels.icon',
        'stylers': [
          {
            'visibility': 'off',
          },
        ],
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 20,
          },
        ],
      },
      {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 17,
          },
          {
            'weight': 1.2,
          },
        ],
      },
      {
        'featureType': 'landscape',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#2f2f36',
          },
        ],
      },
      {
        'featureType': 'poi',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 21,
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 17,
          },
        ],
      },
      {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 29,
          },
          {
            'weight': 0.2,
          },
        ],
      },
      {
        'featureType': 'road.arterial',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 18,
          },
        ],
      },
      {
        'featureType': 'road.local',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 16,
          },
        ],
      },
      {
        'featureType': 'transit',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#000000',
          },
          {
            'lightness': 19,
          },
        ],
      },
      {
        'featureType': 'water',
        'elementType': 'geometry',
        'stylers': [
          {
            'color': '#29292f',
          },
        ],
      },
    ],
  });

  window.onresize = function() {
    map.setZoom(getZoomSize());
  };

  // Make marks and info-windows for markers
  let infowindow = new google.maps.InfoWindow({});
  let marker, i;

  for (let i = 0; i < locations.length; i++) {
    marker = new google.maps.Marker({
      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
      map: map,
      icon: '//maps.google.com/mapfiles/ms/icons/orange.png',
    });
    google.maps.event.addListener(marker, 'click', (function(marker, i) {
      return function() {
        infowindow.setContent(locations[i][0]);
        infowindow.open(map, marker);
      };
    })(marker, i));
  }
};

$(function() { // Document ready
  // Sliders
  $('.creators').slick({
    arrows: false,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
        },
      },
    ],
  });
  $('.partner-slider').slick({
    arrows: false,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  // Slider size gradients
  $(window).on('resize', function() {
    let actualInnerWidth = $('body').prop('clientWidth');
    let containerWidth = $('.container').width();
    $('.grad-left').width((actualInnerWidth - containerWidth) / 2);
    $('.grad-right').width((actualInnerWidth - containerWidth) / 2);
  }).trigger('resize');

  // Menu functionality
  const disableBodyScroll = bodyScrollLock.disableBodyScroll;
  const enableBodyScroll = bodyScrollLock.enableBodyScroll;

  let menuToggle = $('#toggleNav');
  let menuClose = $('#closeNav');
  let menu = $('#navMobile');

  menuToggle.click(function() {
    $(this).toggleClass('is-active');
    menu.toggleClass('is-active');
    disableBodyScroll(menu);
    // $('body').toggleClass('no-scroll');
    // e.preventDefault();
  });
  menuClose.click(function() {
    menuToggle.removeClass('is-active');
    menu.removeClass('is-active');
    enableBodyScroll(menu);
    // $('body').removeClass('no-scroll');
    // e.preventDefault();
  });
  $('#navMobile ul li a').click(function() {
    menuToggle.removeClass('is-active');
    menu.removeClass('is-active');
    enableBodyScroll(menu);
    // $('body').removeClass('no-scroll');
  });
  $(window).resize(function() {
    let w = $(window).width();
    if (w > 960 && menu.hasClass('is-active')) {
      menuToggle.removeClass('is-active');
      menu.removeClass('is-active');
      enableBodyScroll(menu);
      // $('body').removeClass('no-scroll');
    }
  });

  // Smooth scrolling to anchor links
  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top,
    }, 500);
  });

  // Scroll to top
  let scrollToTop = $('#scrollToTop');

  scrollToTop.click(function(e) {
    $('html, body').animate({
      scrollTop: 0,
    }, 500);
    e.preventDefault();
  });

  // Particles
  particlesJS('particles-js', {
    'particles': {
      'number': {
        'value': 160,
        'density': {
          'enable': true,
          'value_area': 800,
        },
      },
      'color': {
        'value': '#ffffff',
      },
      'shape': {
        'type': 'circle',
        'stroke': {
          'width': 0,
          'color': '#000000',
        },
        'polygon': {
          'nb_sides': 5,
        },
        'image': {
          'src': 'img/github.svg',
          'width': 100,
          'height': 100,
        },
      },
      'opacity': {
        'value': 1,
        'random': true,
        'anim': {
          'enable': true,
          'speed': 1,
          'opacity_min': 0,
          'sync': false,
        },
      },
      'size': {
        'value': 3,
        'random': true,
        'anim': {
          'enable': false,
          'speed': 4,
          'size_min': 0.3,
          'sync': false,
        },
      },
      'line_linked': {
        'enable': false,
        'distance': 150,
        'color': '#ffffff',
        'opacity': 0.4,
        'width': 1,
      },
      'move': {
        'enable': true,
        'speed': 1,
        'direction': 'none',
        'random': true,
        'straight': false,
        'out_mode': 'out',
        'bounce': false,
        'attract': {
          'enable': false,
          'rotateX': 600,
          'rotateY': 600,
        },
      },
    },
    'interactivity': {
      'detect_on': 'canvas',
      'events': {
        'onhover': {
          'enable': false,
          'mode': 'bubble',
        },
        'onclick': {
          'enable': false,
        },
        'resize': true,
      },
      'modes': {
        'grab': {
          'distance': 400,
          'line_linked': {
            'opacity': 1,
          },
        },
        'bubble': {
          'distance': 250,
          'size': 0,
          'duration': 2,
          'opacity': 0,
          'speed': 3,
        },
        'repulse': {
          'distance': 400,
          'duration': 0.4,
        },
        'push': {
          'particles_nb': 4,
        },
        'remove': {
          'particles_nb': 2,
        },
      },
    },
    'retina_detect': true,
  });

  // Randomize which title to use and put paint-stroke-class on the last two words
  $('#hero-title').html(function() {
    let elem;
    if ((Math.random() * (10)) < 5) elem = $('#titleOne');
    else elem = $('#titleTwo');

    elem.css('display', 'block');
  });

  // Animation in hero
  let heroAnimation = (function() {
    let breakpoint = 1024;
    let timeoutOpacity;
    let timeoutClass;
    let heroContent = $('#hero .container');
    let heroBg = $('#hero #image');
    let navbarLogoWrap = $('.navbar-brand-wrap');
    let scrollToTop = $('#scrollToTop');
    let navbar = $('.navbar');

    let init = function() {
      // Handles animation depending on browser width
      if ($(window).width() > breakpoint) {
        getHeroAnimation();
      } else {
        getNoHeroAnimation();
      }

      // Handles animation at window resize
      $(window).on('resize', function() {
        if ($(window).width() < breakpoint) {
          getNoHeroAnimation();
          navbarLogoWrap.css('position', 'absolute');
        }
      });

      // Handles sticky nav at scroll
      $(window).scroll(function() {
        if ($(window).width() > breakpoint) {
          if ($(window).scrollTop() >= $(window).height()) {
            makeNavSticky();
            getNoHeroAnimation();
          } else {
            removeStickyNav();
          }
        } else {
          if ($(window).scrollTop() >= 10) {
            makeNavSticky();
          } else {
            removeStickyNav();
          }
        }

      });
    };

    // Creates transitions/animations and adds video
    let getHeroAnimation = function() {
      // hero content animation
      heroContent.css('opacity', '1');
      heroBg.css('opacity', '.6');
      // logo animation
      timeoutOpacity = setTimeout(function() {
        navbarLogoWrap.css('opacity', '1');
      }, 1800);
      timeoutClass = setTimeout(function() {
        navbarLogoWrap.addClass('fixed');
      }, 3000);
    };

    // Cancels every transition/animation and removes video
    let getNoHeroAnimation = function() {
      // remove video
      $('.video-container').remove();
      // clear logo animation
      clearTimeout(timeoutOpacity);
      clearTimeout(timeoutClass);
      navbarLogoWrap.css('opacity', '1');
      navbarLogoWrap.addClass('fixed');
      //hero content
      heroContent.css('transition', 'none');
      heroContent.css('opacity', '1');
      heroBg.css('transition', 'none');
      heroBg.css('opacity', '.6');
      navbarLogoWrap.css('transition', 'none');
      $('.navbar-brand-wrap .navbar-brand').css('transition', 'none');
      $('.navbar-brand-wrap .navbar-brand .logo').css('transition', 'none');
    };

    // Makes navigation sticky
    let makeNavSticky = function() {
      navbar.addClass('is-sticky');
      navbar.css('position', 'fixed');
      scrollToTop.addClass('is-active');
      navbarLogoWrap.css('position', 'fixed');
    };

    // Removes sticky from navigation
    let removeStickyNav = function() {
      navbar.removeClass('is-sticky');
      navbar.css('position', 'absolute');
      scrollToTop.removeClass('is-active');
      navbarLogoWrap.css('position', 'absolute');
    };

    return {
      init: init,
    };
  }());
  heroAnimation.init();

  // About section
  let aboutSection = (function() {
    let aboutSection = $('#about');
    let aboutRow = $('#about .row');
    let closeBtn = $('.close-col');
    let expanded = false;

    let open = function() {
      let aboutRow = $(this);
      if (!expanded) {
        aboutSection.addClass('expanded');
        aboutRow.addClass('expanded');
        closeBtn.addClass('show');
        aboutRow.siblings().addClass('minified');

        $('html, body').animate({
          scrollTop: aboutSection.offset().top - 64,
        }, 500);

        expanded = true;
      }
    };

    let close = function() {
      if (expanded) {
        aboutSection.removeClass('expanded');
        aboutRow.removeClass('expanded');
        closeBtn.removeClass('show');
        aboutRow.siblings().removeClass('minified');

        expanded = false;
      }
    };

    let bindActions = function() {
      aboutRow.on('click', open);
      closeBtn.on('click', close);
    };

    let init = function() {
      bindActions();
      setTimeout(function() {
        initMap();
      }, 2000);
    };

    return {
      init: init,
    };
  }());
  aboutSection.init();
}); // End document ready
